<div class="placeholders">
    <fui-alerts></fui-alerts>
</div>

<fui-background-video id="background-video" [video]="'assets/videos/cafe-blur-480.mp4'"></fui-background-video>
<wbo-login-podium>
    <div class="signin">
        <div class="signin-header">
            <div class="signin-header-media">
                <div class="signin-header-media-object">
                    <fui-pos-logo id="logo" [type]="'fedelta'"></fui-pos-logo>
                </div>
            </div>
        </div>
        <div class="signin-main">
            <form class="form" id="login" name="form" (ngSubmit)="login(loginForm)" #loginForm="ngForm">
                <div class="form-main" *ngIf="active">
                    <div class="form-fields">
                        <div class="form-fields-field">
                            <fui-text-control id="login-username" [label]="'wbo.login.label.username'" name="username"
                                              [(ngModel)]="username" [placeholder]="'wbo.login.placeholder.username'"
                                              required="true" #text_username="ngModel">
                            </fui-text-control>
                        </div>
                        <div class="form-fields-field">
                            <fui-password-control id="login-password" [label]="'wbo.login.label.password'" name="password"
                                              [(ngModel)]="password" [placeholder]="'wbo.login.placeholder.password'"
                                              required="true" #text_password="ngModel"></fui-password-control>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <div class="form-actions-action">
                        <fui-submit-button id="login-button" [disabled]="!loginForm.valid"
                                           [title]="'wbo.login.button.login'"></fui-submit-button>
                    </div>
                </div>
                <div class="form-tools">
                    <div class="form-fields">
                        <div class="form-fields-field">
                            <fui-checkbox-control id="login-remember" [label]="'wbo.login.label.remember'"
                                                  name="remember"
                                                  [(ngModel)]="remember"></fui-checkbox-control>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</wbo-login-podium>
